module.exports = __webpack_public_path__ + "static/media/previous-arrow-active.8c31dce5.svg";